import React from 'react';
import { compose } from 'redux';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import core, { App } from '@gin-betting/core';

import { Loader, NoResults } from 'components';
import globalMessages from 'messages';

const { getHistory } = core.services;

interface OwnProps {
    error?: any;
    isTimeout?: boolean;
    isLoading?: boolean;
    pastDelay?: boolean;
}

type Props = OwnProps & WrappedComponentProps;

class MatchStub extends React.Component<Props> {
    history = getHistory();

    handleRefresh = () => {
        window.location.reload(true); // reload with no cache
    };

    render() {
        const { intl, isLoading, isTimeout, error } = this.props;

        const finalMessage = isTimeout
            ? intl.formatMessage(globalMessages.timeIsUp)
            : error && !isLoading
            ? intl.formatMessage(globalMessages.uploadError)
            : intl.formatMessage(globalMessages.loading);

        return (
            <React.Fragment>
                {isLoading && (
                    <Loader
                        initialProgressValue={0}
                        fetchStatus={App.FetchStatus.LOADING}
                    />
                )}
                <NoResults
                    type={App.PageType.INNER}
                    defaultMessage={finalMessage}
                    error={error && !isLoading}
                    linkHandler={this.handleRefresh}
                />
            </React.Fragment>
        );
    }
}

export default compose<React.ComponentClass<OwnProps>>(injectIntl)(MatchStub);
